<div class="gallery-inner-dialog" [ngClass]="{'loading in': loadingFirst }">
	<!--
	<div class="controls" *ngIf="photos && photos.length > 2 && !loadingLast">
		<button (click)="prevImageClick($event)" class="prev"><i class="fas fa-angle-double-left"></i></button>
		<button (click)="nextImageClick($event)" class="next"><i class="fas fa-angle-double-right"></i></button>
	</div>
	-->
	<ng-image-slider #slider [ngClass]="{'hidden': !loadingFirst && images && images.length == 0 }" [images]="images" [infinite]="true" [showArrow]="false" [imageSize]="{width: '100%', height: 133}" [manageImageRatio]="true" [imagePopup]="false"></ng-image-slider>
	<div *ngIf="images && images.length == 0 && !loadingLast" class="no-photos-message">No photos in this gallery</div>
</div>